<template>
    <div >
        <div v-if="p_showCookiesPolicy_b" class="TQ_center">
            <div class="TQ_maxWidth_900px TQ_inline TQ_verticalAlignMiddle TQ_align_initial TQ_margin_8px">
                <b class="TQ_text_capitalize">
                    {{ ass_strings.oneWord_notice[p_langCode_e]}}.
                </b>
                <div class="TQ_text_capitalize_first_letter TQ_inline">
                    {{ass_strings.sentenceGroup_acceptCookies1[p_langCode_e] }}
                </div>
                <br>
                {{ass_strings.sentenceGroup_acceptCookies2[p_langCode_e] }}
                <tq-link class="TQ_text_uppercase" :p_open-new-tab_b="true" :p_link_s="enum_moveToOptions.terms_cookiePolicy">{{ass_strings.twoWords_cookiePolicy[p_langCode_e] }}</tq-link>
                {{ass_strings.sentenceGroup_acceptCookies3[p_langCode_e] }}
            </div>

            <div @click="pe_approveCookiesPolicy_f" class="TQ_padding_8px TQ_box_shadow TQ_clickable TQ_bg_purple TQ_borderRadius TQ_width_72px TQ_inline TQ_text_capitalize TQ_verticalAlignMiddle TQ_margin_8px">
                <div class="TQ_center">
                    {{ ass_strings.oneWord_accept[p_langCode_e]}}
                </div>
            </div>
        </div>

        <hr v-if="p_showCookiesPolicy_b && p_showTermsOfUse_b">

        <div v-if="p_showTermsOfUse_b" class="TQ_center">
            <div class="TQ_maxWidth_900px TQ_inline TQ_verticalAlignMiddle TQ_align_initial TQ_margin_8px">

                <b class="TQ_text_capitalize">
                    {{ ass_strings.oneWord_notice[p_langCode_e]}}.
                </b>
                <div class="TQ_text_capitalize_first_letter TQ_inline">
                    {{ass_strings.sentenceGroup_updateTerms1[p_langCode_e]}} 31/12/2021,
                    <tq-link class="TQ_text_uppercase" :p_open-new-tab_b="true" :p_link_s="enum_moveToOptions.terms_termsOfUse">{{ ass_strings.twoWords_clickHere[p_langCode_e] }}</tq-link>
                    {{ass_strings.sentenceGroup_updateTerms2[p_langCode_e]}}
                </div>

            </div>
            <div @click="pe_approveTermsOfUse_f" class="TQ_padding_8px TQ_box_shadow TQ_clickable TQ_bg_purple TQ_borderRadius TQ_width_72px TQ_inline TQ_text_capitalize TQ_verticalAlignMiddle TQ_margin_8px">
                <div class="TQ_center">
                    {{ ass_strings.oneWord_accept[p_langCode_e]}}
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import {validator_enum_fb} from "../../../functions/src/shareCode/Share_S_Validator";
import {enum_langCodes, enum_moveToOptions} from "../../../functions/src/shareCode/Share_S_Enum";
import TqLink from "@/components/basic/TqLink";
import {ass_strings} from "../../../functions/src/shareCode/Share_Ass_Dictionary";

export default {
    name: "C_App_AcceptCookiesPolicy",
    components: {TqLink},
    props:{
        p_langCode_e:{
            type: String,
            require: true,
            validator(val){
                return validator_enum_fb(enum_langCodes, val)
            }
        },
        p_showCookiesPolicy_b:{
            type: Boolean,
            require: true,
        },
        p_showTermsOfUse_b:{
            type: Boolean,
            require: true,
        },

        pe_approveCookiesPolicy_f:{
            type: Function,
            require: true,
        },
        pe_approveTermsOfUse_f:{
            type: Function,
            require: true,
        },
    },
    data(){
        return {
            ass_strings : ass_strings,
            enum_moveToOptions : enum_moveToOptions
        }
    }
}
</script>

<style scoped>

</style>